import React from "react";
// import { shell } from "electron";

const SyncInfoModal = ({ isOpen, onClose, isSoundOn, volume }) => {

    const modalStyle = {
        opacity: isOpen ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out 0.5s',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: isOpen ? 'translate(-50%, -50%)' : 'translate(-50%, -200%)',
        zIndex: 9999,
    };
    
    const closeModal = (e) => {
        e.stopPropagation(); // Prevent closing when clicking inside the modal
        onClose();
    };

    const playButtonClickSound = () => {
        const close_click = new Audio('sound/button_sound/Close_BTN.ogg');
        close_click.volume = volume / 100;
        close_click.play();
    };

    return (
        <div className="sync-info-modal" style={modalStyle} onClick={(e) => { closeModal(e); isSoundOn && playButtonClickSound(); }}>
            <div className="sync-info-modal-header">
                <div className="sync-info-logo1"></div>
                <div className="sync-info-logo2"></div>
                <div className="sync-info-modal-close" onClick={onClose}></div>
            </div>
            <div className="sync-info-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="info-main-content">
                    <div>
                        The iPlayMore THUNDER© Influencer Marketing Tool - Ver 1.0
                        <br />
                        <br />
                        How the THUNDER© Influencer Marketing Tool works: Streamers log in using their account to access 
                        various features. This giveaway tool synchronizes when the Streamer clicks on the “sync followers” button 
                        to gather all the active viewers from Twitch livestreams and list them on the User Tab. Then the listed 
                        users can participate in the giveaway. As the Streamer, you use the “Start Selection” button, which will 
                        start a spinning name animation that will stop on the lucky participant that will be revealed first on the 
                        User List with a yellow name; the Streamer will be able now to use the “Start Countdown” with a cinematic 
                        will start with a 30 seconds countdown where the winner will have to type in the platform’s chat to claim 
                        the prize and a win scenario animation will start, if the user doesn’t type in chat and the timer runs out, a 
                        ‘lose scenario’ animation will start, the first name is removed and the whole process must be repeated to 
                        select a fresh winner. The last button, when a winner has been declared, will open the Streamer’s Twitter 
                        account with a pre-written editable tweet with a screenshot of the winner. The tweet will promote both the 
                        streamer and the game.
                        <br />
                        <br />
                        IMPORTANT: no data will be shared by the company with third parties.
                        <br />
                        <br />
                        IMU Studios Inc. Copyright Ownership: All materials, content, and intellectual properties, including but not 
                        limited to text, images, graphics, logos, audio, video, and software, made available on iPlayMore’s 
                        website, publications, or other platforms, are protected by worldwide copyright laws and are privately 
                        owned unless otherwise stated.
                        <br />
                        <br />
                        By accessing or using any copyrighted materials owned by IMU Studios Inc., you acknowledge and agree 
                        to abide by these copyright terms.
                        <br />
                        <br />
                        Disclaimer. If you do not agree with any of these terms, please refrain from accessing or using our 
                        copyrighted materials.
                        <br />
                        <br />
                        For any inquiries regarding this Copyright Disclaimer, please contact IMU Studios Inc. at #20 7528 Upper 
                        Balfour Road, Balfour BC V1L 7E6  <a href="https://www.iplaymore.com" target="_blank">https://www.iplaymore.com</a>  copyright@imustudios.com
                        <br />
                        <br />
                        <ol>
                            <li>
                                THUNDER© (Note: Capitalize title, add copyright notice, update logo)
                                THUNDER© is a team-based hero shooter set in a thrilling high-fantasy, sci-fi open-world, video game.
                            </li>
                            <li>
                                Account - Your Account grants you access to your online inventory of Game Gear.
                            </li>
                            <li>
                                Games - Beginning with THUNDER(c), here is your growing stable of iPlayMore Games.
                            </li>
                            <li>
                                Marketplace - Redeem Game Gear codes and grow your collection of game items.
                            </li>
                            <li>
                                Work with Us - we scout outstanding teams and individuals to help us develop tomorrow’s greatest games.
                            </li>
                            <li>
                                Experiences - (what is this?)
                            </li>
                            <li>
                                TV Show - This is the home of our upcoming streaming TV show.
                            </li>
                            <li>
                                Bonfire Stories - The heart of our game lore, brought front and center for your entertainment.
                            </li>
                            <li>
                                Comic - Our Bonfire stories in a comic book setting.
                            </li>
                            <li>
                                Novels - The depth of our story, as set in our THUNDER© novel series.
                            </li>
                            <li>
                                Music - Truly a music-based project, we offer classical orchestral themes, progressive rock songs, and folk-inspired and techno-driven music to enjoy.
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SyncInfoModal;